import styled from 'styled-components'

export const Container = styled.div`
  padding: 40px;
`

export const Title = styled.h3`
  color: #00577C;
  padding: 0;
  margin: 0;
`

export const Subtitle = styled.h6`
  padding: 0;
  margin: 0 0 20px 0;
  color: #0A345E;
`

interface DragItemProps {
  isDragging: boolean;
}
export const DragItem = styled.div<DragItemProps>`
  display: flex;
  justify-content: space-between;

  padding: 10px;
  border: 1px solid #CDD0D1;
  border-radius: 5px;
  margin: 5px;

  color: #0A345E;
  background: ${props => props.isDragging ? '#C2E0E8' : '#FAFEFF'};
`

export const ButtonRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 50px;
`

export const FormWrapper = styled.div`
  padding-top: 24px;
  .form-field {
    margin: 10px 0;
  }
  .MuiFormControl-root {
    width: 100%;
  }
` 